import type { RichTextBlock } from "@homeinstead/schemas";
import type { PortableTextBlock } from "@portabletext/types";
import type { StepInputRendererProps, StepItem } from "./StepInputRenderer";

import { cn } from "@homeinstead/ui";
import { RichText } from "@homeinstead/ui/components/RichText";
import { resolveTextAlignmentClass } from "./form-item-styles";

const RICH_TEXT_MAX_WIDTH_CLASS: Record<string, string> = {
  "2xs": "max-w-[16rem]",
  full: "max-w-none",
  lg: "max-w-lg",
  md: "max-w-md",
  sm: "max-w-sm",
  xl: "max-w-xl",
  xs: "max-w-xs",
};

function getRichTextMaxWidthClass(value: string | null | undefined): string {
  if (value && value in RICH_TEXT_MAX_WIDTH_CLASS) {
    return RICH_TEXT_MAX_WIDTH_CLASS[value];
  }
  return RICH_TEXT_MAX_WIDTH_CLASS.full;
}

type RichTextBlockInput = Extract<StepItem, { _type: "richTextBlock" }> & {
  maxWidth?: string | null;
  text?: RichTextBlock["text"] | null;
  textAlignment?: RichTextBlock["textAlignment"] | null;
};

export function LeadFormRichTextBlockFormItem({
  input,
  placeholderValues,
  heroVariantStyles,
}: StepInputRendererProps) {
  if (input._type !== "richTextBlock") {
    return null;
  }

  const richTextBlock = input as RichTextBlockInput;
  const value = Array.isArray(richTextBlock.text)
    ? (richTextBlock.text as PortableTextBlock[])
    : [];

  if (value.length === 0) {
    return null;
  }

  const textAlignmentClass = resolveTextAlignmentClass(
    richTextBlock.textAlignment,
  );

  return (
    <RichText
      className={cn(
        getRichTextMaxWidthClass(richTextBlock.maxWidth),
        textAlignmentClass,
      )}
      placeholders={placeholderValues}
      textColor={heroVariantStyles?.richTextColor}
      value={value}
    />
  );
}
